import { useOne } from '@refinedev/core';
import { DynamicUiData } from 'src/UI/dynamicUI/types';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';

export default function useDynamicNonFinancialData(clientId?: string): {
  nonFinancialData: DynamicUiData | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => Promise<DynamicUiData | undefined>;
} {
  const { clientId: currentClientId } = useCurrentClient();
  const effectiveClientId = clientId ?? currentClientId;
  const { data, isLoading, isError, refetch } = useOne<DynamicUiData>({
    resource: `clients/${effectiveClientId}/non-financial-data`,
    id: '',
  });

  const refetchData = async () => {
    const result = await refetch();
    return result.data?.data;
  };

  return {
    nonFinancialData: data?.data,
    isLoading,
    isError,
    refetch: refetchData,
  };
}
